import { PhoneCall } from 'lucide-react'
import { SCHEDULE_CALL_URL } from '../lib/stripe-config'
import { trackSegmentEvent } from '../lib/segment'
import './ScheduleCallCta.css'

/**
 * ScheduleCallCta — the "75% off your first month" upsell offer, shown wherever we nudge a user to
 * upgrade: the out-of-credits modal (OutOfCreditsModal) and the Subscription settings tab
 * (SettingsModal). Booking goes to the shared Calendly link (SCHEDULE_CALL_URL), the same one the
 * transactional out-of-credits email uses, so every touchpoint books the same call.
 *
 * `source` distinguishes which surface the click came from in analytics.
 */
export default function ScheduleCallCta({ source }: { source: string }) {
  return (
    <div className="schedule-call-cta" data-testid="schedule-call-cta">
      <div className="schedule-call-cta__body">
        <div className="schedule-call-cta__title">Get 75% off your first month</div>
        <p className="schedule-call-cta__copy">
          Want to talk it through first? Schedule a call with us and we’ll take{' '}
          <strong>75% off your first month</strong> of the Starter or Pro plan.
        </p>
      </div>
      <a
        className="schedule-call-cta__button"
        href={SCHEDULE_CALL_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackSegmentEvent('Clicked Schedule a Call', { source, offer: '75-off-first-month' })}
        data-analytics-event="schedule-call-cta"
        data-testid="schedule-call-cta-button"
      >
        <PhoneCall size={16} strokeWidth={1.75} aria-hidden />
        Schedule a call
      </a>
    </div>
  )
}
